import { SlideButtonProps } from '../../../types';
import { NextSlideIcon } from '../../atoms/NextSlideIcon';
import { PresentationNavigationButton } from '../../atoms/PresentationNavigationButton';
import { useTranslation } from 'react-i18next';

export const NextSlideButton = (props: SlideButtonProps) => {
    const { t } = useTranslation();
    const { onClick, disabled, classNames } = props;
    return (
        <PresentationNavigationButton type="button" onClick={onClick} className={`${classNames}`} testId="NextButton" disabled={disabled}>
            <span className="sr-only">{t('Slide.Button.Next')}</span>
            <NextSlideIcon />
        </PresentationNavigationButton>
    );
};
